/**
 * ============================================================================
 * THE DEPARTURE LOUNGE — Pipeline Quiz
 * Standalone section above The Showroom
 * ============================================================================
 */

(function() {
  'use strict';

  var pipeline = {
    step: 0,        // 0=gate, 1=prefs, 2=results
    path: null,
    pathLabel: '',
    answers: {},
    subStep: 0      // which preference group is active (0-based)
  };

  var PATHS = {
    spice: {
      label: 'Making something',
      groups: [
        {
          id: 'protein', label: "What are you cooking?", multi: true,
          options: [
            { val: 'chicken', label: 'Chicken' },
            { val: 'beef', label: 'Beef' },
            { val: 'lamb', label: 'Lamb' },
            { val: 'seafood', label: 'Seafood' },
            { val: 'pork', label: 'Pork' },
            { val: 'vegetables', label: 'Vegetables' }
          ]
        },
        {
          id: 'vibe', label: "What's the vibe?", multi: true,
          options: [
            { val: 'smoky', label: 'Smoky & bold', sub: 'charcoal, BBQ, deep smoke' },
            { val: 'spicy-complex', label: 'Spicy & complex', sub: 'heat, layered spice, chili' },
            { val: 'warm-earthy', label: 'Warm & earthy', sub: 'cumin, turmeric, cinnamon' },
            { val: 'bright-fresh', label: 'Bright & fresh', sub: 'citrus, herbs, light' },
            { val: 'sweet-aromatic', label: 'Sweet & aromatic', sub: 'baking, dessert, holiday' },
            { val: 'comfort', label: 'Comfort food', sub: 'roasts, stews, home cooking' }
          ]
        },
        {
          id: 'adventure', label: "Feeling adventurous?", multi: false, optional: true,
          options: [
            { val: 'familiar', label: 'Keep it familiar' },
            { val: 'new', label: 'Take me somewhere new' },
            { val: 'either', label: 'Surprise me' }
          ]
        }
      ]
    },
    tea: {
      label: 'Sipping something',
      groups: [
        {
          id: 'mood', label: "What sounds good right now?", multi: true,
          options: [
            { val: 'cozy', label: 'Cozy & familiar', sub: 'warm, nostalgic, comfort' },
            { val: 'bold', label: 'Bold & rich', sub: 'strong, full-bodied, dark' },
            { val: 'light', label: 'Light & delicate', sub: 'gentle, floral, subtle' },
            { val: 'sweet', label: 'Something sweet', sub: 'fruity, dessert, honeyed' },
            { val: 'earthy', label: 'Something earthy', sub: 'mineral, smoky, deep' },
            { val: 'adventurous', label: "Something I've never tried", sub: 'unusual, rare, surprising' }
          ]
        },
        {
          id: 'caffeine', label: "Caffeine?", multi: false,
          options: [
            { val: 'yes', label: 'Yes please' },
            { val: 'light', label: 'Keep it light' },
            { val: 'none', label: 'None tonight' },
            { val: 'any', label: "Don't care" }
          ]
        },
        {
          id: 'format', label: "How do you take it?", multi: true, optional: true,
          options: [
            { val: 'milk', label: 'With milk' },
            { val: 'honey', label: 'With honey or sugar' },
            { val: 'straight', label: 'Straight' },
            { val: 'iced', label: 'Iced' },
            { val: 'any', label: "I'll figure it out" }
          ]
        }
      ]
    },
    wellness: {
      label: 'Fighting something off',
      groups: [
        {
          id: 'symptom', label: "What's going on?", multi: true,
          options: [
            { val: 'sleep', label: "Can't sleep", sub: "mind or body won't stop" },
            { val: 'stuffed', label: 'Stuffed up', sub: 'congested, sore throat' },
            { val: 'stress', label: 'Stressed & wound up', sub: 'anxiety, tension' },
            { val: 'energy', label: 'No energy', sub: 'fatigue, dragging' },
            { val: 'stomach', label: "Stomach's off", sub: 'digestive issues' },
            { val: 'ache', label: 'Achy & inflamed', sub: 'joint pain, inflammation' },
            { val: 'blah', label: 'Just feeling off', sub: 'flat, not yourself' }
          ]
        },
        {
          id: 'approach', label: "How do you want to tackle it?", multi: false,
          options: [
            { val: 'essentials', label: 'Just the essentials', sub: 'the core products' },
            { val: 'holistic', label: 'The full support kit', sub: 'wellness + spices' },
            { val: 'everything', label: "Everything you've got", sub: 'maximum coverage' }
          ]
        }
      ]
    }
  };

  var cardData = [];
  var gateImages = {};
  var gateLabel = 'Select your gate';

  function loadCardData() {
    try {
      var el = document.getElementById('dlQuizTagData');
      if (el) cardData = JSON.parse(el.textContent);
    } catch (e) { /* silent */ }
  }

  function loadGateConfig() {
    var section = document.getElementById('DepartureLoungePipeline');
    if (!section) return;
    gateLabel = section.dataset.gateLabel || 'Select your gate';
    gateImages = {
      spice: section.dataset.imgSpice || '',
      tea: section.dataset.imgTea || '',
      wellness: section.dataset.imgWellness || '',
      nexus: section.dataset.imgNexus || ''
    };
  }

  function scoreCards() {
    var tags = [];
    if (pipeline.path) tags.push('path:' + pipeline.path);
    Object.keys(pipeline.answers).forEach(function(p) {
      (pipeline.answers[p] || []).forEach(function(v) {
        if (v !== 'any' && v !== 'either') tags.push(p + ':' + v);
      });
    });
    if (!tags.length) return [];
    var pathTag = 'path:' + pipeline.path;
    var results = [];
    cardData.forEach(function(card) {
      var ct = Array.isArray(card.tags) ? card.tags.map(function(t) { return t.trim().toLowerCase(); }) : (card.tags || '').split(',').map(function(t) { return t.trim().toLowerCase(); });
      if (!ct.length || ct.indexOf(pathTag) === -1) return;
      var score = 0;
      tags.forEach(function(qt) {
        if (qt === pathTag) return;
        if (ct.indexOf(qt.toLowerCase()) > -1) score++;
      });
      if (pipeline.answers.adventure && pipeline.answers.adventure[0] !== 'either' && ct.indexOf('adventure:either') > -1) score += 0.5;
      ['caffeine', 'format'].forEach(function(p) {
        if (pipeline.answers[p] && ct.indexOf(p + ':any') > -1) score += 0.25;
      });
      // Wellness path: card must match at least one selected symptom
      if (pipeline.path === 'wellness' && pipeline.answers.symptom && pipeline.answers.symptom.length > 0) {
        var hasSymptomMatch = false;
        pipeline.answers.symptom.forEach(function(s) {
          if (ct.indexOf('symptom:' + s) > -1) hasSymptomMatch = true;
        });
        if (!hasSymptomMatch) return;
      }

      if (score > 0) results.push({ name: card.name, hook: card.hook || '', image: card.image || '', score: score });
    });
    results.sort(function(a, b) { return b.score - a.score; });
    return results;
  }


  /* ── ACTIVATE SHOWROOM ── */

  function activateShowroom(cardName) {
    var btn = document.querySelector('.category-btn[data-collection="departure-lounge"]');
    if (btn) btn.click();
    if (cardName) {
      setTimeout(function() {
        var cards = document.querySelectorAll('.departure-card');
        cards.forEach(function(card) {
          if ((card.dataset.cardName || '') !== cardName) return;
          var vb = card.querySelector('.departure-view-collection-btn');
          if (!vb) return;
          if (typeof window.departureState !== 'undefined') {
            window.departureState.selectedCard = vb.dataset.cardName;
            window.departureState.selectedHook = vb.dataset.transportHook;
            window.departureState.linkedHandles = (vb.dataset.linkedHandles || '').split(',').filter(function(h) { return h.trim(); });
            window.departureState.mode = 'products';

            // Inflate deferred collections that contain linked products
            if (typeof window.inflateCollection === 'function') {
              var jsonEl = document.getElementById('pairingHandleMap');
              if (jsonEl) {
                try {
                  var map = JSON.parse(jsonEl.textContent);
                  var inflated = {};
                  window.departureState.linkedHandles.forEach(function(h) {
                    var entry = map[h.trim()];
                    if (entry && entry.collection && !inflated[entry.collection]) {
                      inflated[entry.collection] = true;
                      window.inflateCollection(entry.collection);
                    }
                  });
                } catch (e) { /* ignore */ }
              }
            }
          }
          if (typeof window.showDepartureLounge === 'function') window.showDepartureLounge();
        });
        scrollToShowroom();
      }, 300);
    } else {
      setTimeout(scrollToShowroom, 200);
    }
  }

  function scrollToShowroom() {
    var el = document.querySelector('.tea-spice-filter-section');
    if (el) {
      var y = el.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }


  /* ── BOX 1: SELECT YOUR GATE ── */

  function renderBox1() {
    pipeline.step = 0;
    pipeline.path = null;
    pipeline.answers = {};
    pipeline.pathLabel = '';
    pipeline.subStep = 0;
    renderBoxes();

    var area = document.getElementById('dlQuestionContent');
    if (!area) return;

    var gates = [
      { val: 'spice',    label: 'Making something',      sub: 'cooking, building a meal',     imgKey: 'spice' },
      { val: 'tea',      label: 'Sipping something',           sub: 'a feeling, a moment, a ritual', imgKey: 'tea' },
      { val: 'wellness', label: 'Fighting something off', sub: 'a problem to solve',            imgKey: 'wellness' },
      { val: 'nexus',    label: 'Exploring',              sub: 'just browsing, surprise me',    imgKey: 'nexus' }
    ];

    var html = '<div class="dl-q-body"><div class="dl-gate-layout">' +
      '<div class="dl-gate-section">' +
      '<span class="dl-gate-section-label">Quiz Gate</span>' +
      '<div class="dl-gate-cards">';

    gates.forEach(function(g) {
      if (g.val === 'nexus') {
        html += '</div></div>';
        html += '<div class="dl-gate-divider"><span class="dl-gate-divider-line"></span></div>';
        html += '<div class="dl-gate-section dl-gate-section--nexus">' +
          '<span class="dl-gate-section-label">Self-serve</span>' +
          '<div class="dl-gate-nexus">';
      }
      var img = gateImages[g.imgKey];
      var nexusClass = g.val === 'nexus' ? ' dl-gate-card--nexus' : '';
      html += '<button class="dl-gate-card' + nexusClass + '" data-val="' + g.val + '">';
      if (img) {
        html += '<div class="dl-gate-card-img"><img src="' + esc(img) + '" alt="' + esc(g.label) + '" loading="lazy"></div>';
      }
      html += '<div class="dl-gate-card-text">' +
        '<span class="dl-gate-card-label">' + esc(g.label) + '</span>' +
        '<span class="dl-gate-card-sub">' + esc(g.sub) + '</span>' +
        '</div></button>';
    });

    html += '</div></div></div></div>';
    area.innerHTML = html;

    area.querySelectorAll('.dl-gate-card').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var val = btn.dataset.val;
        area.querySelectorAll('.dl-gate-card').forEach(function(b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        if (val === 'nexus') {
          activateShowroom(null);
          return;
        }
        pipeline.path = val;
        pipeline.pathLabel = PATHS[val].label;
        pipeline.step = 1;
        pipeline.subStep = 0;
        renderBoxes();
        renderPrefGroup();
      });
    });
  }


  /* ── BOX 2: PREFERENCES — One group at a time ── */

  function renderPrefGroup() {
    var area = document.getElementById('dlQuestionContent');
    if (!area) return;
    var pd = PATHS[pipeline.path];
    if (!pd) return;

    var groupIndex = pipeline.subStep;
    if (groupIndex >= pd.groups.length) {
      showResults();
      return;
    }

    var group = pd.groups[groupIndex];
    var isLast = groupIndex === pd.groups.length - 1;

    var html = '<div class="dl-q-body">' +
      '<div class="dl-q-header">' +
      '<h3 class="dl-q-title">' + group.label + '</h3>' +
      (group.optional ? '<p class="dl-q-subtitle">Optional — skip if you like</p>' : '') +
      '</div>';

    html += '<div class="dl-q-options dl-q-options--centered" data-multi="' + group.multi + '" data-group="' + group.id + '">';
    group.options.forEach(function(o) {
      var sel = (pipeline.answers[group.id] && pipeline.answers[group.id].indexOf(o.val) > -1) ? ' selected' : '';
      html += '<button class="dl-q-opt' + sel + '" data-val="' + o.val + '" data-group="' + group.id + '">' +
        '<span class="dl-q-opt-label">' + o.label + '</span>' +
        (o.sub ? '<span class="dl-q-opt-sub">' + esc(o.sub) + '</span>' : '') +
        '</button>';
    });
    html += '</div></div>';

    html += '<div class="dl-q-actions">';
    html += '<button class="dl-q-submit" id="dlNext" disabled>' +
      (isLast ? "Show me where I'm going" : 'Next') + '</button>';
    if (group.optional) {
      html += '<button class="dl-q-secondary" id="dlSkip">Skip</button>';
    }
    html += '<button class="dl-q-secondary" id="dlExit">Show me everything</button>';
    html += '</div>';

    area.innerHTML = html;

    // Option clicks
    area.querySelectorAll('.dl-q-opt').forEach(function(b) {
      b.addEventListener('click', function() {
        var gid = b.dataset.group, val = b.dataset.val;
        var container = b.closest('.dl-q-options');
        var multi = container.dataset.multi === 'true';
        if (!pipeline.answers[gid]) pipeline.answers[gid] = [];

        if (!multi) {
          container.querySelectorAll('.dl-q-opt').forEach(function(x) { x.classList.remove('selected'); });
          pipeline.answers[gid] = [val];
          b.classList.add('selected');
        } else {
          if (val === 'any' || val === 'either') {
            container.querySelectorAll('.dl-q-opt').forEach(function(x) { x.classList.remove('selected'); });
            pipeline.answers[gid] = [val];
            b.classList.add('selected');
          } else {
            var idx = pipeline.answers[gid].indexOf(val);
            if (idx > -1) { pipeline.answers[gid].splice(idx, 1); b.classList.remove('selected'); }
            else {
              ['any', 'either'].forEach(function(w) {
                var wi = pipeline.answers[gid].indexOf(w);
                if (wi > -1) { pipeline.answers[gid].splice(wi, 1); var wb = container.querySelector('[data-val="' + w + '"]'); if (wb) wb.classList.remove('selected'); }
              });
              pipeline.answers[gid].push(val);
              b.classList.add('selected');
            }
          }
        }

        // Enable/disable next button
        var nextBtn = document.getElementById('dlNext');
        if (nextBtn) nextBtn.disabled = !(pipeline.answers[gid] && pipeline.answers[gid].length > 0);

        // Update the preference sub-boxes in the header
        renderBoxes();
      });
    });

    // Next / submit
    document.getElementById('dlNext').addEventListener('click', function() {
      pipeline.subStep++;
      var pd2 = PATHS[pipeline.path];
      if (pipeline.subStep >= pd2.groups.length) {
        showResults();
      } else {
        renderBoxes();
        renderPrefGroup();
      }
    });

    // Skip (optional groups)
    var skipBtn = document.getElementById('dlSkip');
    if (skipBtn) {
      skipBtn.addEventListener('click', function() {
        pipeline.subStep++;
        var pd2 = PATHS[pipeline.path];
        if (pipeline.subStep >= pd2.groups.length) {
          showResults();
        } else {
          renderBoxes();
          renderPrefGroup();
        }
      });
    }

    // Early exit
    document.getElementById('dlExit').addEventListener('click', function() { activateShowroom(null); });
  }


  /* ── RESULTS ── */

  function showResults() {
    pipeline.step = 2;
    renderBoxes();
    var scored = scoreCards();
    var area = document.getElementById('dlQuestionContent');
    if (!area) return;
    var top = scored.slice(0, 4);

    var html;
    if (!top.length) {
      html = '<div class="dl-q-body"><div class="dl-q-header"><h3 class="dl-q-title">Let\'s browse</h3>' +
        '<p class="dl-q-subtitle">We\'ll show you everything we\'ve got.</p></div></div>' +
        '<div class="dl-q-actions"><button class="dl-q-submit" id="dlBrowse">Browse destinations</button>' +
        '<button class="dl-q-secondary" id="dlBack">\u2190 Change answers</button></div>';
    } else {
      html = '<div class="dl-q-body"><div class="dl-q-header"><h3 class="dl-q-title">Your destinations</h3>' +
        '<p class="dl-q-subtitle">Pick one to explore.</p></div><div class="dl-result-cards">';
      top.forEach(function(c) {
        html += '<button class="dl-result-card" data-card-name="' + esc(c.name) + '">';
        if (c.image) {
          html += '<div class="dl-result-card-img"><img src="' + esc(c.image) + '" alt="' + esc(c.name) + '" loading="lazy"></div>';
        }
        html += '<div class="dl-result-info"><span class="dl-result-name">' + esc(c.name) + '</span>' +
          (c.hook ? '<span class="dl-result-hook">' + esc(c.hook) + '</span>' : '') +
          '</div></button>';
      });
      html += '</div></div><div class="dl-q-actions">' +
        '<button class="dl-q-secondary" id="dlBack">\u2190 Change answers</button>' +
        '<button class="dl-q-secondary" id="dlReset">Start over</button></div>';
    }

    area.innerHTML = html;

    var browse = document.getElementById('dlBrowse');
    if (browse) browse.addEventListener('click', function() { activateShowroom(null); });

    area.querySelectorAll('.dl-result-card').forEach(function(b) {
      b.addEventListener('click', function() { activateShowroom(b.dataset.cardName); });
    });

    var back = document.getElementById('dlBack');
    if (back) back.addEventListener('click', function() {
      pipeline.step = 1;
      pipeline.subStep = 0;
      renderBoxes();
      renderPrefGroup();
    });

    var reset = document.getElementById('dlReset');
    if (reset) reset.addEventListener('click', renderBox1);
  }


  /* ── PIPELINE BOXES ── */

  function renderBoxes() {
    var el = document.getElementById('dlPipelineBoxes');
    if (!el) return;
    var h = '';
    var pd = pipeline.path ? PATHS[pipeline.path] : null;

    // Box 1: Gate
    if (pipeline.step === 0) {
      h += '<div class="dl-pipe-box active"><span class="dl-pipe-label">' + esc(gateLabel) + '</span></div>';
    } else {
      h += '<div class="dl-pipe-box answered" data-go="gate"><span class="dl-pipe-label">' + esc(pipeline.pathLabel) + '</span></div>';
    }

    // Box 2: Preferences — split into sub-boxes per group
    if (pipeline.step === 0) {
      // Not yet at prefs — show single future box
      h += '<div class="dl-pipe-box future"><span class="dl-pipe-label">Preferences</span></div>';
    } else if (pipeline.step >= 1 && pd) {
      // Show sub-boxes for each preference group
      h += '<div class="dl-pipe-pref-group">';
      pd.groups.forEach(function(g, i) {
        var cls = 'dl-pipe-sub';
        var label = g.label;
        var answerText = '';

        if (pipeline.step === 1 && i === pipeline.subStep) {
          cls += ' active';
        } else if (pipeline.step === 1 && i < pipeline.subStep) {
          cls += ' answered';
          answerText = summarizeGroup(g.id);
        } else if (pipeline.step === 2) {
          cls += ' answered';
          answerText = summarizeGroup(g.id);
        } else {
          cls += ' future';
        }

        h += '<div class="' + cls + '" data-pref-index="' + i + '">';
        if (answerText) {
          h += '<span class="dl-pipe-sub-answer">' + esc(answerText) + '</span>';
        } else {
          h += '<span class="dl-pipe-sub-label">' + esc(label) + '</span>';
        }
        h += '</div>';
      });
      h += '</div>';
    }

    // Box 3: Destinations
    if (pipeline.step === 2) {
      h += '<div class="dl-pipe-box gate active"><span class="dl-pipe-label">Destinations</span></div>';
    } else {
      h += '<div class="dl-pipe-box gate future"><span class="dl-pipe-label">Destinations</span></div>';
    }

    el.innerHTML = h;

    // Click on gate box to go back
    var gateBox = el.querySelector('[data-go="gate"]');
    if (gateBox) {
      gateBox.addEventListener('click', renderBox1);
    }

    // Click on answered sub-boxes to go back to that group
    el.querySelectorAll('.dl-pipe-sub.answered').forEach(function(sub) {
      sub.addEventListener('click', function() {
        var idx = parseInt(sub.dataset.prefIndex);
        pipeline.step = 1;
        pipeline.subStep = idx;
        renderBoxes();
        renderPrefGroup();
      });
    });
  }

  function summarizeGroup(gid) {
    var vals = pipeline.answers[gid];
    if (!vals || !vals.length) return '';
    if (vals.length === 1 && (vals[0] === 'any' || vals[0] === 'either')) return '';
    var s = vals.join(', ');
    return s.length > 18 ? s.substring(0, 15) + '...' : s;
  }

  function esc(s) { var d = document.createElement('div'); d.appendChild(document.createTextNode(s || '')); return d.innerHTML; }

  function init() {
    if (!document.getElementById('DepartureLoungePipeline')) return;
    loadCardData();
    loadGateConfig();
    renderBox1();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();